import { render, staticRenderFns } from "./ReportGdsLogDetail.vue?vue&type=template&id=90c15b42&lang=pug"
import script from "./ReportGdsLogDetail.vue?vue&type=script&lang=js"
export * from "./ReportGdsLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90c15b42')) {
      api.createRecord('90c15b42', component.options)
    } else {
      api.reload('90c15b42', component.options)
    }
    module.hot.accept("./ReportGdsLogDetail.vue?vue&type=template&id=90c15b42&lang=pug", function () {
      api.rerender('90c15b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/ReportGdsLogDetail.vue"
export default component.exports